<mat-card appearance="outlined" class="mat-elevation-z1 mat-card-scrollable cssload-container">
    <mat-card-header>
        <mat-card-title>
            <span class="d-block">{{ 'Presence.Title' | translate }}</span>
            <span class="subheader d-block">
                {{ 'Presence.Updated' | translate }}
                @if (presence(); as presence) {
                    {{ presence.time | date: 'HH:mm' }}
                }
            </span>
        </mat-card-title>
        <div class="ml-auto d-flex gap-2 align-items-center">
            @if (isLoading()) {
                <div class="d-flex align-items-center justify-content-center" style="width: 48px; height: 48px">
                    <mat-spinner [diameter]="24" />
                </div>
            } @else {
                <button mat-icon-button (click)="showPresenceEdit()">
                    <mat-icon>edit</mat-icon>
                </button>
                @if (presence()?.presencePowerPointFileData) {
                    <button mat-icon-button (click)="sendToPresenter()">
                        <mat-icon>visibility</mat-icon>
                    </button>
                }
                <button mat-icon-button (click)="reload()">
                    <mat-icon>refresh</mat-icon>
                </button>
            }
        </div>
    </mat-card-header>
    <mat-card-content>
        @if (presence(); as presence) {
            <h2>{{ 'Presence.PresentVotes' | translate }}</h2>
            <b class="value-display">
                {{ presence.presentVotes | slNumber }}
                ({{ presence.presentVotesPercentage * 100 | slNumber: 2 }}%)
            </b>
            <br />
            <br />

            <!-- present shareholders -->
            <h2>{{ 'Presence.PresentShareholders' | translate }}</h2>
            <h3>{{ 'Presence.NumberOfPeople' | translate }}</h3>
            <b class="value-display">{{ presence.presentShareholders | slNumber }}</b>
            <h3>{{ 'Presence.NumberOfVotes' | translate }}</h3>
            <b class="value-display">
                {{ presence.presentShareholdersVotes | slNumber }}
                ({{ presence.presentShareholdersVotesPercentage * 100 | slNumber: 2 }}%)
            </b>
            <br />
            <br />

            <!-- present independent proxy -->
            <h2>{{ 'Presence.IndependentProxy' | translate }}</h2>
            <h3>{{ 'Presence.NumberOfRepresentedShareholders' | translate }}</h3>
            <b class="value-display">{{ presence.representedByIndependentProxy | slNumber }}</b>
            <h3>{{ 'Presence.NumberOfVotes' | translate }}</h3>
            <b class="value-display">
                {{ presence.representedByIndependentProxyVotes | slNumber }}
                ({{ presence.representedByIndependentProxyVotesPercentage * 100 | slNumber: 2 }}%)
            </b>
            <br />
            <br />

            <!-- present third party proxies -->
            <h2>{{ 'Presence.ThirdPartyProxies' | translate }}</h2>
            <h3>{{ 'Presence.NumberOfRepresentedShareholders' | translate }}</h3>
            <b class="value-display">{{ presence.representedByThirdPartyProxy | slNumber }}</b>
            <h3>{{ 'Presence.NumberOfVotes' | translate }}</h3>
            <b class="value-display">
                {{ presence.representedByThirdPartyProxyVotes | slNumber }}
                ({{ presence.representedByThirdPartyProxyVotesPercentage * 100 | slNumber: 2 }}%)
            </b>
        }
    </mat-card-content>
</mat-card>
